import { clearActiveExperiments, getActiveExperiments } from '@atc/optimizely-toolkit';

import experimentDuck from '@/ducks/experimentDuck.js';

/**
 * Middleware to collect server-side Optimizely decisions and prepare them for client propagation
*/
export default function withOptimizelyExperiments() {
    return async (ctx) => {
        ctx.store.dispatch(experimentDuck.creators.setExperiments({
            userId: ctx.data.ATC_ID,
            experiments: [...getActiveExperiments(ctx.data.ATC_ID)],
        }));

        if (typeof window === 'undefined') {
            clearActiveExperiments(ctx.data.ATC_ID);
        }
    };
}

export function withResetOptimizelyExperiments() {
    return async (ctx) => {
        if (typeof window === 'undefined') {
            clearActiveExperiments(ctx.data.ATC_ID);
        }
    };
}
